import { benefitsEnrollmentGuard, youthBenefitsEnrollmentGuard } from "@/modules/enrollment/router/guardians"

export default [
  {
    path: "/sarah-layout-enrollment",
    component: () => import("@/layouts/enrollment/EnrollmentLayout.vue"),
    children: [
      {
        // Users landing from the Youth Benefit Enrollment Email / SMS link
        path: "/enroll",
        name: "enroll",
        redirect: "/login"
      },
      {
        path: "/enroll-setup",
        name: "enroll-setup",
        component: () => import("@/modules/enrollment/pages/enroll/EnrollPage.vue"),
        beforeEnter: benefitsEnrollmentGuard
      },
      {
        path: "/youth-membership-enroll-setup",
        name: "youth-membership-enroll-setup",
        component: () => import("@/modules/enrollment/pages/youth-membership-enroll/YouthMembershipEnrollPage.vue"),
        beforeEnter: youthBenefitsEnrollmentGuard
      },
      {
        path: "/enrollment/forbidden",
        name: "enrollment-forbidden",
        meta: { requiresAuth: true },
        component: () => import("@/modules/enrollment/pages/NotAllowedToEnrollPage.vue")
      }
    ]
  },
  {
    path: "/enroll-landing-layout",
    component: () => import("@/modules/enrollment/components/LandingLayout.vue"),
    children: [
      {
        // Users landing from the Lob Letter QR Code / link (Only for whitelisted companies)
        path: "/start",
        name: "enroll-start",
        redirect: "/login"
      },
      {
        // Users (non-youth) landing from all enrollment campaign Email / SMS link
        path: "/vitable",
        name: "enroll-landing",
        redirect: "/login"
      },
      {
        path: "/vitable/about",
        name: "enroll-landing-about",
        meta: { requiresAuth: false },
        component: () => import("@/modules/enrollment/pages/enroll-landing/about/About.vue")
      },
      {
        path: "/vitable/how-it-works",
        name: "enroll-landing-how-it-works",
        meta: { requiresAuth: false },
        component: () => import("@/modules/enrollment/pages/enroll-landing/how-it-works/HowItWorks.vue")
      },
      {
        path: "/vitable/faqs",
        name: "enroll-landing-faqs",
        meta: { requiresAuth: false },
        component: () =>
          import("@/modules/enrollment/pages/enroll-landing/frequently-asked-questions/FrequentlyAskedQuestions.vue")
      }
    ]
  }
]
